const MODULE_NAME = 'fulcrum/container/Project/FilePreview'

const UPDATE_PREVIEW_LOADING = MODULE_NAME + '/UPDATE_PREVIEW_LOADING'
const UPDATE_PREVIEW_SHOW = MODULE_NAME + '/UPDATE_PREVIEW_SHOW'
const UPDATE_PREVIEW_FILE = MODULE_NAME + '/UPDATE_PREVIEW_FILE'

export {
  MODULE_NAME,
  UPDATE_PREVIEW_FILE,
  UPDATE_PREVIEW_LOADING,
  UPDATE_PREVIEW_SHOW
}